module.exports = __webpack_public_path__ + "img/Banco_do_Brasil.39e5babe.svg";